import { DEPLOYMENT_ENV } from './environment';

interface ApiConfig {
    serverURLs: {
        settings: string;
        MAX: string;
    };
}

export const apiConfig: ApiConfig = {
    serverURLs: {
        settings:
            process.env.NEXT_PUBLIC_ENV === DEPLOYMENT_ENV.PROD
                ? 'https://settings.zillowhomeloans.com/api'
                : 'https://settings.dev.zillowhomeloans.net/api',
        MAX:
            process.env.NEXT_PUBLIC_ENV === DEPLOYMENT_ENV.PROD
                ? 'https://mortgageapi.zillow.com'
                : 'https://mortgageapi.qa.zillow.net',
    },
};
